import React from 'react';
import LiferayApi from "../services/LiferayApi";
import * as Constants from "../js/Constants";

class GlobalModule extends React.Component {

    constructor() {
        super();
        console.debug("Cargando módulo general");
        window.LiferayApi = LiferayApi;
        window.GlobalExtensionConstants = Constants;
        window.simulateGlobalClick = function (elem) {
            // Create our event (with options)
            var evt = new MouseEvent('click', {
                bubbles: true,
                cancelable: true,
                view: window
            });
            // If cancelled, don't dispatch our event
            var canceled = !elem.dispatchEvent(evt);
            evt.stopPropagation()
        };
        window.objToString = function(obj) {
            var str = '';
            for (var p in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, p)) {
                    str += p + '::' + obj[p] + '\n';
                }
            }
            return str;
        }
        window.formatDateToDdMmYyyy = function (dateString) {
            const date = new Date(dateString);
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            return `${day}/${month}/${year}`;
        };

        window.formatDateToDdMmYyyyHhMMss = function (dateString) {
            const date = new Date(dateString);
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            const hour = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            return `${day}/${month}/${year} - ${hour}:${minutes}`;
        };

        window.timestampToDdMmYyyy = function (timestamp) {
            const date = new Date(timestamp);
            return window.formatDateToDdMmYyyyHhMMss(date);
        }

        LiferayApi.test();

        this.state = {
        };
    }

    render() {
        return (
            <>
            </>
        )
    }
}

export default GlobalModule;
